export default "__VITE_ASSET__EDMOMZhn__"